import { InfoOutlined } from "@mui/icons-material";
import { Box, FormControlLabel, Switch, useTheme } from "@mui/material";
import { FC } from "react";
import { Tooltip } from "../../../components";
import { useLocalization } from "../../../hooks/useLocalization";

interface WhitelistSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const WhitelistSwitch: FC<WhitelistSwitchProps> = ({
  checked,
  onChange,
}) => {
  const { t } = useLocalization();
  const theme = useTheme();

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 3, flex: 0.5 }}>
      <FormControlLabel
        control={
          <Switch
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
          />
        }
        label={t("licenses.whitelist")}
        labelPlacement="start"
        sx={{
          marginLeft: 0,
          "& .MuiFormControlLabel-label": {
            fontSize: 12,
            fontWeight: 500,
            color: theme.colors.text[checked ? 7 : 0],
            width: "auto",
            ml: 0,
            mr: 1,
          },
        }}
      />

      <Tooltip message={t("licenses.whitelistSwitchTooltip")} placement="right">
        <InfoOutlined
          sx={{
            fontSize: 18,
            color: theme.colors.secondary[6],
            cursor: "pointer",
          }}
        />
      </Tooltip>
    </Box>
  );
};
